module.exports = __webpack_public_path__ + "img/cg_oldtown_count.35964d7a.jpg";